import React, {useEffect,useState} from 'react';
import moment from 'moment-timezone';
import {connect} from 'react-redux';

import { useGetEventsQuery } from '../../redux/services/eventApi';
import { useGetProviderAvailabilitiesQuery } from '../../redux/services/providerAvailabilityApi';
import { getStartAndEndDate } from '../../components/calendar/calendarUtils';
import useUser from '../../hooks/useUser';
import useIsMobile from '../../hooks/useIsMobile';

import AppDashboard from '../AppDashboard';
import AvailabilityCalendarScreen from '../../components/availabilities/AvailabilityCalendarScreen';

const AvailabilityZonePage = ({
  startHour,
  endHour,
  calendarView,
  showWeekends,
}) => {
  const [date, setDate] = useState(new Date());
  const isMobile = useIsMobile();
  const _calendarView = calendarView || (isMobile ? 'day' : 'week');
  const {startDate, endDate} = getStartAndEndDate({
    date, 
    calendarView: _calendarView,
    timezone: moment.tz.guess(),
  });
  const user = useUser();
  const providerId = user?.provider?.id;
  const timezone = user?.provider?.timezone || moment.tz.guess();
  useEffect(() => {
    setDate(moment().tz(timezone).toDate());
  }, [timezone]);
  const eventsQuery = useGetEventsQuery({
    provider_id: providerId,
    start_time: startDate, 
    end_time: endDate,
  }, {skip: !providerId});
  const availabilityQuery = useGetProviderAvailabilitiesQuery(
    {provider_id: providerId}, 
    {skip: !providerId}
  );
  const childProps = {
    loading: (
      eventsQuery.isLoading 
      || availabilityQuery.isLoading 
      || !availabilityQuery.isSuccess
      || !user
      || !providerId
    ),
    events: eventsQuery?.data?.data || eventsQuery?.data || [],
    availabilities: availabilityQuery?.data?.data || [],
    date,
    onDateChange: (e, dt) => setDate(dt),
    // onCalendarViewChange: (e, v) => setCalendarView(v),
    error: eventsQuery?.isError ? availabilityQuery.error : null,
    startHour,
    endHour,
    calendarView: _calendarView,
    showWeekends,
    timezone,
  };
  return (
    <AppDashboard 
      isLoading={childProps.loading}
      title='Availability Zones'
    >
      <AvailabilityCalendarScreen {...childProps} />
    </AppDashboard>
  );
};

const mapState = state => ({
  ...(state?.calendarSettings || {}),
});

const mapDispatch = dispatch => ({});

export default connect(mapState, mapDispatch)(AvailabilityZonePage);